// config.js
export const SERVER_ADDRESS = `https://trocalia.net`;
export const SHARE_BASE_URL = `https://trocalia.net`;


// export const SERVER_ADDRESS = "https://trocalia.loca.lt";

// export const SERVER_ADDRESS = "http://192.168.1.138:3000";
// export const SHARE_BASE_URL = "http://192.168.1.138:19006";

// export const SERVER_ADDRESS = "http://192.168.1.142:3000";
// export const SHARE_BASE_URL = "http://192.168.1.45:19006";

// export const SERVER_ADDRESS = "https://0c74-79-154-98-200.ngrok-free.app";
// export const SHARE_BASE_URL = "http://172.20.10.2:19006";
